<div class="text-center mb-8" data-cy="summary-subtitle">
  {{ "modules.evcQuote.steps.carDetails.fields.summary.subtitle" | translate }}
</div>

<div class="flex flex-wrap justify-center" *ngIf="cars">
  <div *ngFor="let car of cars['controls']; index as i" class="w-full sm:w-auto">
    <div class="saved-car text-center align-middle" [attr.data-cy]="'saved-car-' + (i + 1)">
      <div *ngIf="carDetailsVisible[i]" class="saved-car--content">
        <div>
          <div class="saved-car--title te-text-gradient-drive font-sans font-medium">
            {{ "modules.evcQuote.steps.carDetails.fields.summary.savedCar.title" | translate }} {{ i + 1 }}
          </div>
          <div class="font-sans font-normal text-grey-dark60 py-6 border-b">
            {{ "modules.evcQuote.steps.carDetails.fields.summary.savedCar.brand" | translate }}:
            {{ car.get(fields.carBrandName).value }}
          </div>

          <div class="font-sans font-normal text-grey-dark60" [ngClass]="{'my-6': !car.get(fields.options)?.value, 'mt-2': car.get(fields.options)?.value}">
            {{ "modules.evcQuote.steps.carDetails.fields.summary.savedCar.model" | translate }}:
            {{ getCarModelName(i, car.get(fields.carModel).value) }}
          </div>

          <div class="font-sans font-normal text-grey-dark60 truncate" [ngClass]="{'pb-2': car.get(fields.options)?.value}" *ngIf="car.get(fields.options)?.value">
            {{ "modules.evcQuote.steps.carDetails.fields.summary.savedCar.options" | translate }}: {{ car.get(fields.options).value }}
          </div>
        </div>

        <button class="btn-secondary py-2 w-full" (click)="remove(i)" [attr.data-cy]="'delete-car-' + (i + 1)">
          {{ "modules.evcQuote.steps.carDetails.fields.summary.savedCar.delete" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="add-another-car" *ngIf="addNewButtonVisible()" data-cy="add-another-car">
    <div>
      <button class="btn-add-new" (click)="addNew()">
        <img
          class="bg-grey-light box-shadow-small rounded-full mb-8"
          src="assets/evc/img/plus.svg"
          [alt]="'modules.evcQuote.steps.carDetails.fields.summary.addNew.desktop' | translate"
        />
        {{ "modules.evcQuote.steps.carDetails.fields.summary.addNew.desktop" | translate }}
      </button>
    </div>
  </div>
</div>
